import NiceModal, { useModal } from '@ebay/nice-modal-react';
import ContactCard from '@/components/Contacts/ContactCard';
import Loading from '@/components/Loading';
import Drawer from '@/components/Modals/Drawer';
import Section from '@/components/Section';
import useContact from '@/hooks/useContact';

const ContactDrawer = NiceModal.create(({ contactId }: { contactId: string }) => {
  const modal = useModal('show-contact-drawer');
  const contact = useContact(contactId as string);

  return (
    <Drawer modal={modal} title="Contact">
      {contact.isLoading ? (
        <Section>
          <Loading />
        </Section>
      ) : (
        <ContactCard contactId={contactId} />
      )}
    </Drawer>
  );
});

export default ContactDrawer;
